import { setFakeErrorLogForDraft } from "../Engine/Fakes/FakeErrorLog";
import { resumeLastSuspendedUpload, suspendNextUpload } from "../Engine/Externals/Attachments/Tasks/UploadToDriveTask";
import { getStoredLogItems } from "../Engine/Testing/TestLogging/ITestLogger";
import { IForm } from "../Engine/Form/IForm";

import { initMetricsTrackerForTests } from "./Internals/Metrics/InitMetricsTracker";

let testingMode = typeof window === "undefined" ? false : Boolean(window.__CANDY_FORMS_TESTING_MODE__);
let screenshotTestingMode = false;

function getCookieValue(name: string): undefined | string {
    if (typeof document === "undefined") {
        return undefined;
    }
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        const lastPart = parts.pop();
        if (lastPart == undefined) {
            throw new Error("IvalidProgramState");
        }
        return lastPart.split(";").shift();
    }
    return undefined;
}

const testingModeViaCookies = Boolean(getCookieValue("candy.testing-mode"));
const screenshotTestingModeViaCookies = Boolean(getCookieValue("candy.screenshots-testing-mode"));

export function isTestingMode(): boolean {
    return testingMode || testingModeViaCookies;
}

export function isScreenshotTestingMode(): boolean {
    return screenshotTestingMode || screenshotTestingModeViaCookies;
}

export function setTestingMode(value: boolean): void {
    testingMode = value;
    window.document.body.classList.add("testing-mode");
}

let exposedForm: IForm | undefined;

export function setExposedForm(form: IForm): void {
    exposedForm = form;
}

export function exposeIntoWindowTestingModeHandleForIntegrationTests(): void {
    window.__CANDY_FORMS_ENABLE_TESTING_MODE__ = () => setTestingMode(true);
    window.__CANDY_FORMS_ENABLE_TESTING_MODE_SCREENSHOTS__ = () => {
        screenshotTestingMode = true;
        window.document.body.classList.add("testing-mode");
    };
    window.__CANDY_FORMS_TESTING_MODE__SuspendNextUpload = suspendNextUpload;
    window.__CANDY_FORMS_TESTING_MODE__ResumeLastSuspendedUpload = resumeLastSuspendedUpload;
    window.__CANDY_FORMS_TESTING_MODE__SetFakeErrorLogForDraft = setFakeErrorLogForDraft;
    window.__CANDY_FORMS_TESTING_MODE__GetStoredLogItems = getStoredLogItems;
    window.__CANDY_FORMS_TESTING_MODE__InitMetricsTracker = initMetricsTrackerForTests;
    window.__CANDY_FORMS_TESTING_MODE__FormObject = () => exposedForm;
}
